import { createFileRoute, redirect } from "@tanstack/react-router";

// Backward-compat redirect — old /prompt-templates/new links land on the new path.
export const Route = createFileRoute("/_admin/prompt-templates/new")({
  beforeLoad: () => {
    throw redirect({ to: "/prompt-engine/templates/new", replace: true });
  },
  component: () => null,
});
